import "core-js/modules/es6.object.assign";
import "antd/lib/select/style/css";
import _Select from "antd/lib/select";
import "core-js/modules/es6.function.name";
import * as tslib_1 from "tslib";
import { Field } from "formik";
import * as React from "react";
export var Select = function Select(_a) {
  var name = _a.name,
      validate = _a.validate,
      children = _a.children,
      restProps = tslib_1.__rest(_a, ["name", "validate", "children"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref) {
    var value = _ref.field.value,
        _ref$form = _ref.form,
        setFieldValue = _ref$form.setFieldValue,
        setFieldTouched = _ref$form.setFieldTouched;
    return React.createElement(_Select, Object.assign({
      onChange: function onChange(v) {
        return setFieldValue(name, v);
      },
      onBlur: function onBlur() {
        return setFieldTouched(name);
      },
      value: value
    }, restProps), children);
  });
};

Select.renderOptions = function (options) {
  return options.map(function (_a, index) {
    var label = _a.label,
        restProps = tslib_1.__rest(_a, ["label"]);

    return React.createElement(_Select.Option, Object.assign({
      key: "select-option-" + index
    }, restProps), label);
  });
};

Select.Option = _Select.Option;
Select.OptGroup = _Select.OptGroup;